/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import { Link, useNavigate } from "react-router-dom";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { appConstants } from "utils/appConstants";
import {
  Box,
  Card,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  Modal,
} from "@mui/material";
import MDBox from "components/MDBox";
import LoginLayout from "layouts/loginLayout/loginLayout";
import MuiPhoneNumber from "material-ui-phone-number";
import OTPInput from "react-otp-input";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { userResendOTP } from "utils/authApi";
import { useDispatch } from "react-redux";
import { showResMsg } from "utils/generic";
import { forgotPasswordCustomer } from "utils/authApi";
import { genericMessage } from "utils/genericMessages";
import { setCustomerPassword } from "utils/authApi";
import {
  InlineFormMessage,
  InlineFieldMessage,
} from "components/InlineFeedback/InlineFeedback";
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  display: "grid",
  justifyContent: "center",
};
function CustomerResetPass({ ...props }) {
  const [emailErr, setemailErr] = useState(false);
  const [emailTitleErr, setemailTitleErr] = useState("");
  const [openForgotResponseModal, setOpenForgotResponseModal] = useState(false);
  const [phoneNumberErr, setPhoneNumberErr] = useState(false);
  const [mobileOTPErr, setMobileOTPErr] = useState(false);
  const [mobileOTP, setMobileOTP] = useState();
  const [disable, setDisabled] = useState();
  const [otpUI, setOtpUI] = useState();
  const [passwordErr, setPasswordErr] = useState(false);
  const [confirmPasswordTitleErr, setConfirmPasswordTitleErr] = useState("");
  const [passwordTitleErr, setPasswordTitleErr] = useState("");
  const [confirmPasswordErr, setConfirmPasswordErr] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordUI, setPasswordUI] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [values, setValues] = React.useState({
    emailAddress: "",
    currentMail: "",
    onlyPhoneNumber: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    loginURL: appConstants.loginURL,
  });
  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };
  if (
    sessionStorage.getItem("LOGIN_EMAIL") != undefined ||
    sessionStorage.getItem("LOGIN_EMAIL") != null
  )
    values.currentMail = sessionStorage
      .getItem("LOGIN_EMAIL")
      .replaceAll('"', "");

  const handleMobileOTP = (val) => {
    if (/^[0-9]*$/.test(val)) {
      setMobileOTP(val);
      values.mobileOTP = val;
    }
  };
  let mandateFlag = false;
  const checkMobile = async () => {
    try {
      setFormError("");
      setFormSuccess("");
      if (values.onlyPhoneNumber.toString().trim() !== "") {
        if (
          values.phoneNumber.toString().trim() === "" ||
          values.phoneNumber.toString().trim().length < 12
        ) {
          setPhoneNumberErr(true);
          mandateFlag = true;
        } else {
          setPhoneNumberErr(false);
          values.mobileNumberExist = true;
        }
      } else {
        setPhoneNumberErr(true);
        mandateFlag = true;
      }

      if (mandateFlag) {
        return;
      }
      setIsSubmitting(true);
      values.sendOtpTo = "Mobile";
      userResendOTP(
        values,
        "customer/resendOTP",
        (data) => {
          setIsSubmitting(false);
          if (data.Result_Status) {
            setDisabled(true);
            setOtpUI(true);
            setPasswordUI(false);
            setFormSuccess("OTP sent successfully to your mobile number.");
          } else {
            setFormError(data.Result_Message || "Failed to send OTP");
          }
          showResMsg(
            data.Result_Status
              ? "OTP sent successfully! "
              : data.Result_Message,
            1000,
            data.Result_Status
          );
        },
        dispatch
      );
    } catch (error) {
      setIsSubmitting(false);
      setFormError("An unexpected error occurred. Please try again.");
      console.log("Catch in checkEmail==", error);
    }
  };
  const validateOTP = async () => {
    try {
      setFormError("");
      setFormSuccess("");
      if (
        values.mobileOTP?.length !== 6 ||
        !Number.isInteger(Number.parseInt(values.mobileOTP))
      ) {
        setMobileOTPErr(true);
        mandateFlag = true;
      } else setMobileOTPErr(false);
      if (mandateFlag) {
        return;
      }

      setIsSubmitting(true);
      values.sendOtpTo = "Mobile";
      forgotPasswordCustomer(
        values,
        (data) => {
          setIsSubmitting(false);
          if (data.Result_Status) {
            setDisabled(true);
            setOtpUI(false);
            setPasswordUI(true);
            setFormSuccess(
              "OTP verified successfully. Please enter your new password."
            );
          } else {
            setFormError(data.Result_Message || "Invalid OTP");
          }
          showResMsg(
            data.Result_Status
              ? genericMessage.otpValidate
              : data.Result_Message,
            1000,
            data.Result_Status
          );
        },
        dispatch
      );
    } catch (error) {
      setIsSubmitting(false);
      setFormError("An unexpected error occurred. Please try again.");
      console.log("Catch in checkEmail==", error);
    }
  };
  const setPassword = async () => {
    try {
      setFormError("");
      setFormSuccess("");
      if (values.password.toString().trim() === "") {
        console.log("values");
        setPasswordErr(true);
        setPasswordTitleErr("Password can't be blank");
        mandateFlag = true;
      } else setPasswordErr(false);
      if (values.confirmPassword.toString().trim() === "") {
        setConfirmPasswordErr(true);
        setConfirmPasswordTitleErr("Confirm Password can't be blank");
        mandateFlag = true;
      } else setConfirmPasswordErr(false);
      if (mandateFlag) {
        return;
      }
      if (
        values.password.toString().trim() !==
        values.confirmPassword.toString().trim()
      ) {
        setFormError("Password and Confirm Password must match.");
        showResMsg(
          "Password and Confirm Password should be same.",
          1000,
          false
        );
        return;
      }
      setIsSubmitting(true);
      setCustomerPassword(
        values,
        (data) => {
          setIsSubmitting(false);
          if (data.Result_Status) {
            setFormSuccess("Password reset successfully! Redirecting...");
          } else {
            setFormError(data.Result_Message || "Failed to set password");
          }
          showResMsg(
            data.Result_Status
              ? genericMessage.paswordSetSuccess
              : data.Result_Message,
            1000,
            data.Result_Status,
            navigate,
            "/customerLogin"
          );
        },
        dispatch
      );
    } catch (error) {
      setIsSubmitting(false);
      setFormError("An unexpected error occurred. Please try again.");
      console.log("Catch in checkEmail==", error);
    }
  };
  const setPhoneValues = (phone, country) => {
    values.onlyPhoneNumber = phone.slice(country.dialCode.length);
    values.phoneNumber = phone.slice(country.dialCode.length);
    values.phoneNumber = phone;
    values.countryCode = "+" + country.dialCode;
  };

  return (
    <LoginLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Forgot Password?
          </MDTypography>
        </MDBox>

        <Grid container spacing={2} p={5}>
          {(formError || formSuccess) && (
            <Grid item xs={12} lg={12}>
              <InlineFormMessage
                message={formError || formSuccess}
                type={formError ? "error" : "success"}
                onClose={() => {
                  setFormError("");
                  setFormSuccess("");
                }}
              />
            </Grid>
          )}

          <Grid item xs={12} lg={12}>
            <MuiPhoneNumber
              defaultCountry={"au"}
              type="text"
              label="Mobile Number"
              variant="standard"
              fullWidth
              disabled={disable || isSubmitting}
              value={values.phoneNumber}
              onChange={(phone, country) => setPhoneValues(phone, country)}
            />
            <InlineFieldMessage
              error={phoneNumberErr ? "Enter valid 10 digit number" : ""}
            />
          </Grid>

          <Grid
            item
            xs={12}
            lg={12}
            style={{ display: "flex", justifyContent: "center" }}
          >
            {emailErr ? <span style={errMsg}> {emailTitleErr}</span> : ""}
          </Grid>
          {otpUI && (
            <Grid container spacing={4} p={3}>
              <Grid
                item
                xs={12}
                lg={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <OTPInput
                  shouldAutoFocus={true}
                  inputStyle="otp-input-style"
                  numInputs={6}
                  separator={<span></span>}
                  inputProps={{
                    pattern: "^[0-9]+$",
                    maxLength: 6,
                  }}
                  value={mobileOTP}
                  onChange={handleMobileOTP}
                  type="text"
                  isInputNum
                  renderInput={(props) => (
                    <input {...props} style={{ width: "2em" }} />
                  )}
                />

                <MDTypography
                  component="a"
                  onClick={() => !isSubmitting && checkMobile()}
                  variant="button"
                  fontWeight="bold"
                  color="info"
                  textGradient
                  style={{
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                    opacity: isSubmitting ? 0.6 : 1,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Resend OTP&nbsp;&nbsp;
                </MDTypography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={12}
                mt={0}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <InlineFieldMessage
                  error={mobileOTPErr ? "Mobile OTP can't be blank" : ""}
                />
              </Grid>
            </Grid>
          )}
          {passwordUI && (
            <>
              <Grid item xs={8} lg={8}>
                <FormControl variant="standard" fullWidth>
                  <InputLabel htmlFor="standard-adornment-password">
                    New Password
                  </InputLabel>
                  <Input
                    id="standard-adornment-password"
                    type={showNewPassword ? "text" : "password"}
                    value={values.password}
                    onChange={handleChange("password")}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          edge="end"
                        >
                          {showNewPassword ? (
                            <VisibilityOff
                              onClick={() =>
                                setShowNewPassword(!showNewPassword)
                              }
                            />
                          ) : (
                            <Visibility
                              onClick={() =>
                                setShowNewPassword(!showNewPassword)
                              }
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password"
                  />
                  <InlineFieldMessage
                    error={passwordErr ? passwordTitleErr : ""}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={8}>
                <FormControl variant="standard" fullWidth>
                  <InputLabel htmlFor="standard-adornment-password">
                    Confirm Password
                  </InputLabel>
                  <Input
                    id="standard-adornment-password"
                    type={showConfirmPassword ? "text" : "password"}
                    value={values.confirmPassword}
                    onChange={handleChange("confirmPassword")}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          edge="end"
                        >
                          {showConfirmPassword ? (
                            <VisibilityOff
                              onClick={() =>
                                setShowConfirmPassword(!showConfirmPassword)
                              }
                            />
                          ) : (
                            <Visibility
                              onClick={() =>
                                setShowConfirmPassword(!showConfirmPassword)
                              }
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password"
                  />
                  <InlineFieldMessage
                    error={confirmPasswordErr ? confirmPasswordTitleErr : ""}
                  />
                </FormControl>
              </Grid>
            </>
          )}
        </Grid>
        <Grid
          container
          spacing={4}
          pb={3}
          pl={3}
          style={{ justifyContent: "center" }}
        >
          <Grid item xs={12} lg={3}>
            <Link
              to={"/customerLogin"}
              style={{ pointerEvents: isSubmitting ? "none" : "auto" }}
            >
              <MDButton
                variant="gradient"
                color="warning"
                fullWidth
                disabled={isSubmitting}
              >
                Cancel
              </MDButton>
            </Link>
          </Grid>

          <Grid item xs={12} lg={3}>
            <MDButton
              variant="gradient"
              color="success"
              fullWidth
              loading={isSubmitting}
              loadingLabel={
                otpUI
                  ? "Verifying..."
                  : passwordUI
                  ? "Updating..."
                  : "Sending..."
              }
              disabled={isSubmitting}
              onClick={
                otpUI ? validateOTP : passwordUI ? setPassword : checkMobile
              }
            >
              Submit
            </MDButton>
          </Grid>
        </Grid>

        <Modal
          open={openForgotResponseModal}
          onClose={() => setOpenForgotResponseModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Card sx={style}>
            <Box>
              <MDTypography
                type="h3"
                id="modal-modal-title"
                center={true}
                size={18}
              >
                Temporary password has been sent to your email address.
              </MDTypography>

              {/* <Height val={10} />
          <CustomText type="p" color={colorScheme.gray} center={true} size={13.5}>
            Are you sure?
          </CustomText> */}

              {/* <Button className="modal-btn cancel-btn" onClick={() => setOpenLiveMapProviderModal(false)}>
              Cancel
            </Button> */}
              <Grid
                container
                id="modal-modal-description"
                sx={{ mt: 2, justifyContent: "center" }}
              >
                <Link to={"/login"}>
                  <MDButton
                    color="success"
                    className="modal-btn action-btn btn-success"
                    onClick={() => setOpenForgotResponseModal(false)}
                  >
                    Ok
                  </MDButton>
                </Link>
              </Grid>
            </Box>
          </Card>
        </Modal>
      </Card>
    </LoginLayout>
  );
}

export default CustomerResetPass;
